<mat-accordion multi>
  @for (section of categories(); track categoryTrackBy($index, section)) {
    <mat-expansion-panel
      class="!mb-4 !overflow-hidden !rounded-lg"
      [ngClass]="{
        'category-complete':
          showCategoryStatusStyles() && isSectionComplete(section),
        'category-in-progress':
          showCategoryStatusStyles() && isSectionInProgress(section)
      }"
      [expanded]="expandedCategories().has(section.category)"
      (opened)="panelOpened.emit(section.category)"
      (closed)="panelClosed.emit(section.category)"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>
          @if (showCompletionIcon() && isSectionComplete(section)) {
            <mat-icon class="!h-5 !w-5 !text-xl text-green-700"
              >check_circle</mat-icon
            >
          }
          {{ section.label | titlecase }}
        </mat-panel-title>
        <mat-panel-description>
          @if (isSectionComplete(section)) {
            <span
              class="rounded-xl bg-green-700 px-3 py-1 text-xs font-medium uppercase tracking-wide text-white"
              >Complete</span
            >
          } @else {
            {{ section.completed }}/{{ section.total }} Steps
          }
        </mat-panel-description>
      </mat-expansion-panel-header>

      <div class="flex flex-col gap-4 py-4">
        @for (step of section.steps; track step.ref.id) {
          <pr-setup-wizard-step [step]="step" [allSteps]="allSteps()" />
        }

        @if (section.steps.length === 0) {
          <div class="p-8 text-center italic text-slate-400">
            No steps in this category.
          </div>
        }
      </div>
    </mat-expansion-panel>
  }
</mat-accordion>
